<template>
    <div class="field__wrapper">
        <div class="field__player">
            <div
                class="field__corner-circle"
                :class="`corner${i}`"
                v-for="i in 4"
            ></div>

            <div class="field__gantry">
                <div class="field__gantry-area-box">
                    <div class="field__gantry-area-square">
                        <div class="field__gantry-square"></div>
                    </div>
                    <div class="field__gantry-area-circle"></div>
                </div>

                <div class="field__gantry-center">
                    <div class="field__gantry-center--line"></div>
                    <div class="field__gantry-center--circle"></div>
                </div>

                <div class="field__gantry-area-box">
                    <div class="field__gantry-area-box right">
                        <div class="field__gantry-area-square">
                            <div class="field__gantry-square"></div>
                        </div>
                        <div class="field__gantry-area-circle"></div>
                    </div>
                </div>
            </div>

            <div
                class="player-container"
                v-if="!isMobile || (isMobile && tabsSelected === 'home')"
            >
                <div
                    class="player__row"
                    :class="`row-${lineUpField.home.playerList.length}`"
                    v-for="(item, index) in lineUpField.home.playerList"
                    :key="index"
                >
                    <div
                        class="player__row-list"
                        :class="[
                            `row-${item.pos}`,
                            `list-${item.child.length}`,
                        ]"
                        v-for="(sec, index2) in item.child"
                        :key="index2"
                    >
                        <Navigation
                            :id="sec.playerId"
                            :category="'player'"
                            :name="sec.name"
                        >
                            <div class="player__row-list--item">
                                <div class="player__row--item--avatar--box">
                                    <div
                                        class="player__row--item--container-card"
                                    >
                                        <div
                                            class="player__row--item--yellow-card"
                                            v-if="sec.yellowCard && !sec.yellowRed"
                                        ></div>
                                        <div
                                            class="player__row--item--red-card"
                                            v-if="sec.redCard && !sec.yellowRed"
                                        ></div>
                                        <div
                                            class="player__row--item--yellowred-card yellowred"
                                            v-if="sec.yellowRed"
                                        ></div>
                                    </div>
                                    <div
                                        class="field-player__row-container__icon-card-right bottom"
                                    >
                                        <div
                                            class="match__event-type ownGoal"
                                            v-if="sec.ownGoal"
                                        ></div>
                                        <div
                                            class="match__event-type goal"
                                            v-if="sec.goal"
                                        ></div>
                                        <div
                                            class="match__event-type var"
                                            v-if="sec.var"
                                        ></div>
                                        <div
                                            class="match__event-type miss"
                                            v-if="sec.penMiss"
                                        ></div>
                                        <div
                                            class="match__event-type penaltyGoal"
                                            v-if="sec.penaltyGoal"
                                        ></div>
                                        <div
                                            class="match__event-type miss"
                                            v-if="sec.penaltyPenMiss"
                                        ></div>
                                    </div>
                                    <div
                                        class="field-player__row-container__icon-card-left"
                                    >
                                        <div
                                            class="match__event-type subst"
                                            v-if="sec.subst"
                                        ></div>
                                    </div>
                                    <Icon
                                        :logoUrl="sec.logo"
                                        :category="'country'"
                                        class="player__row--item--avatar--img"
                                    ></Icon>
                                </div>
                                <div class="player__row-list--item--name">
                                    {{ sec.name }}
                                </div>
                            </div>
                        </Navigation>
                    </div>
                </div>
            </div>

            <div
                class="player-container right"
                v-if="!isMobile || (isMobile && tabsSelected === 'away')"
            >
                <div
                    class="player__row"
                    :class="`row-${lineUpField.away.playerList.length}`"
                    v-for="(item, index) in lineUpField.away.playerList"
                    :key="index"
                >
                    <div
                        class="player__row-list"
                        :class="[
                            `row-${item.pos}`,
                            `list-${item.child.length}`,
                        ]"
                        v-for="(sec, index2) in item.child"
                        :key="index2"
                    >
                        <Navigation
                            :id="sec.playerId"
                            :category="'player'"
                            :name="sec.name"
                        >
                            <div class="player__row-list--item">
                                <div class="player__row--item--avatar--box">
                                    <div
                                        class="player__row--item--container-card"
                                    >
                                        <div
                                            class="player__row--item--yellow-card"
                                            v-if="sec.yellowCard && !sec.yellowRed"
                                        ></div>
                                        <div
                                            class="player__row--item--red-card"
                                            v-if="sec.redCard && !sec.yellowRed"
                                        ></div>
                                        <div
                                            class="player__row--item--yellowred-card yellowred"
                                            v-if="sec.yellowRed"
                                        ></div>
                                    </div>
                                    <Icon
                                        :logoUrl="sec.logo"
                                        :category="'country'"
                                        class="player__row--item--avatar--img"
                                    ></Icon>
                                </div>
                                <div class="player__row-list--item--name">
                                    {{ sec.name }}
                                </div>
                            </div>
                        </Navigation>
                    </div>
                </div>
            </div>

            <!-- <div class="field__gantry right">
                <div class="field__gantry-square"></div>
                <div class="field__gantry-area-square"></div>
                <div class="field__gantry-area-circle"></div>
            </div> -->
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    data() {
        return {};
    },
    props: ["lineUpField", "tabsSelected"],
    computed: {
        ...mapGetters(["isMobile"]),
    },
};
</script>

<style scoped>
.field__wrapper {
    width: 100%;
    height: 424px;
    background-color: var(--primary-800);
    padding: 16px;
    border-radius: var(--size-radius-200);
    position: relative;
    box-sizing: border-box;
}
.field__player {
    border: 3px solid var(--color-border-default-neutral);
    height: 100%;
    border-radius: 8px;
    position: relative;
    z-index: 2;
    overflow: hidden;
}
/* corner */
.field__corner-circle {
    border: 3px solid var(--color-border-default-neutral);
    width: 24px;
    height: 24px;
    border-radius: 50%;
    position: absolute;
    z-index: 1;
}
.field__corner-circle.corner1 {
    top: 0px;
    left: 0px;
    transform: translate3d(-50%, -50%, 0);
}
.field__corner-circle.corner2 {
    top: 0px;
    right: 0px;
    transform: translate3d(50%, -50%, 0);
}
.field__corner-circle.corner3 {
    left: 0px;
    bottom: 0px;
    transform: translate3d(-50%, 50%, 0);
}
.field__corner-circle.corner4 {
    right: 0px;
    bottom: 0px;
    transform: translate3d(50%, 50%, 0);
}

@media (min-width: 768px){
    /* for test */

    /* gantry */
    .field__gantry {
        position: absolute;
        top: 50%;
        transform: translate3d(0, -50%, 0);
        left: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 100%;
    }
    .field__gantry-area-box {
        position: relative;
        width: 118px;
        height: 188px;
    }
    .field__gantry-square {
        border: 3px solid var(--color-border-default-neutral);
        height: 100px;
        width: 50%;
        position: relative;
        top: 50%;
        left: 8px;
        transform: translate3d(0, -50%, 0);
        border-radius: 8px;
    }
    .field__gantry-area-square {
        border: 3px solid var(--color-border-default-neutral);
        width: 118px;
        border-radius: 8px;
        height: 188px;
        position: absolute;
        left: -27px;
        overflow: hidden;
        background-color: var(--primary-800);
        z-index: 1;
    }
    .field__gantry-area-circle {
        position: absolute;
        border: 3px solid var(--color-border-default-neutral);
        height: 88px;
        width: 50px;
        border-radius: 50%;
        right: 12px;
        top: 48px;
    }
    .field__gantry-area-box.right {
        position: absolute;
        top: 50%;
        transform: unset;
        right: 0;
        transform: translate3d(0, -50%, 0) rotate(180deg);
    }
    .field__gantry-center {
        height: 100%;
        position: relative;
    }
    .field__gantry-center--line {
        height: 100%;
        width: 3px;
        background-color: var(--color-border-default-neutral);
    }
    .field__gantry-center--circle {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        border: 3px solid var(--color-border-default-neutral);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
    }
    .row-4 {
        width: 25%;
    }
    .row-5 {
        width: 20%;
    }
    .row-6 {
        width: calc(100% / 6);
    }

    .list-1 {
        height: 100%;
    }
    .list-2 {
        height: calc(100% / 2);
    }

    .list-3 {
        height: calc(100% / 3);
    }
    .list-4 {
        height: calc(100% / 4);
    }

    .list-5 {
        height: calc(100% / 5);
    }
    .list-6 {
        height: calc(100% / 6);
    }
}

.player-container {
    position: relative;
    z-index: 3;
    display: flex;
    width: 50%;
    height: 100%;
}
.player__row {
    flex-shrink: 0;
}
.player__row-list {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.player__row-list--item {
    text-align: center;
    position: relative;
    font-size: var(--typography-caption-size-large);
    letter-spacing: 0.2px;
}
.player__row-list--item:hover {
    cursor: pointer;
}
.player__row-list--item:hover .player__row-list--item--name {
    color: var(--primary-500);
}
.player__row--item--avatar--box {
    width: 40px;
    height: 40px;
    background-color: var(--white-1000);
    border-radius: 50%;
    margin: auto;
    display: block;
    position: relative;
}
.player__row--item--avatar--box img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    transform: translate3d(0.5px, 2px, 0);
}
.player-container.right {
    position: absolute;
    right: 0;
    top: 0;
}
.player__row-list--item--name {
    color: #ffffff;
    margin-top: 4px;
    word-break: break-word;
    display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 限制显示行数 */
  overflow: hidden;
}

.player__row--item--avatar--box .player__row--item--avatar--img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    transform: translate3d(0.5px, 2px, 0);
    border-radius: 50%;
    position: relative;
    top: -1px;
}
.player__row--item--avatar--box .player__row--item--avatar--img img {
    border-radius: 50%;
}

.player__row--item--container-card {
    position: absolute;
    top: -5px;
    left: -5px;
    z-index: 3;
}
.player__row--item--red-card {
    width: 12px;
    height: 16px;
    border-radius: 4px;
    transform: rotate(-20deg);
    background-color: var(--card-red);
}
.player__row--item--yellowred-card {
    width: 16px;
    height: 16px;
}
.player__row--item--yellow-card {
    width: 10px;
    height: 14px;
    border-radius: 4px;
    transform: rotate(-20deg);
    background-color: var(--card-yellow);
}
.field-player__row-container__icon-card-right.bottom {
    position: absolute;
    bottom: -5px;
    right: -10px;
    z-index: 3;
}

@media(max-width: 768px) {
    /* for test */
    .field__wrapper {
        height: 400px;
    }
    .field__gantry {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
    }
    .field__gantry-area-box {
        position: relative;
        width: 100%;
        z-index: 2;
    }
    .field__gantry-area-square {
        border: 3px solid var(--color-border-default-neutral);
        position: absolute;
        left: 50%;
        top: -15px;
        height: 50px;
        width: 45%;
        z-index: 3;
        transform: translate3d(-50%, 0, 0);
        background-color: var(--primary-800);
    }

    .field__gantry-square {
        position: absolute;
        top: -10px;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        border: 3px solid var(--color-border-default-neutral);
        width: 54%;
        height: 30px;
    }
    .field__gantry-area-circle {
        position: absolute;
        border: 3px solid var(--color-border-default-neutral);
        height: 50px;
        width: 88px;
        border-radius: 50%;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        top: 4px;
    }
    .field__gantry-area-box.right {
        /* transform: rotate(180deg)translate(-50%, 0 ,0);; */
        bottom: 22px;
    }
    .field__gantry-area-box.right .field__gantry-square {
        bottom: -4px;
        top: unset;
    }
    .field__gantry-area-box.right .field__gantry-area-circle {
        top: -34px;
    }
    .field__gantry-mobile-ui {
        width: 100%;
    }
    .field__gantry-center {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
    .field__gantry-center--line {
        height: 3px;
        width: 100%;
        background-color: var(--color-border-default-neutral);
    }
    .field__gantry-center--circle {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        border: 3px solid var(--color-border-default-neutral);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
    }
    .player-container {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        flex-direction: column;
    }
    .player-container.right {
        top: 0%;
        left: 0;
        flex-direction: column-reverse;
    }
    .player__row {
        align-items: baseline;
        display: flex;
        width: 100%;
    }
    .row-4 {
        height: 25%;
    }
    .row-5 {
        height: 20%;
    }
    .row-6 {
        height: calc(100% / 6);
    }

    .list-1 {
        width: 100%;
    }
    .list-2 {
        width: calc(100% / 2);
    }

    .list-3 {
        width: calc(100% / 3);
    }
    .list-4 {
        width: calc(100% / 4);
    }

    .list-5 {
        width: calc(100% / 5);
    }
    .list-6 {
        width: calc(100% / 6);
    }
    .field__corner-circle.corner3 {
        display: none;
    }
    .field__corner-circle.corner4 {
        display: none;
    }
    .field__gantry-center--line {
        display: none;
    }
    .field__gantry-area-box.right {
        display: none;
    }
    .field__gantry-center--circle {
        top: 100%;
    }
    .field__gantry-area-square {
        top: -7px;
    }
    .field__gantry-area-circle {
        top: 15px;
    }
}
</style>

<style>
.player__row--item--avatar--box .player__row--item--avatar--img img {
    border-radius: 50%;
}
</style>
